<template>
  <div class="login-container">
    <el-row>
      <el-col :lg="14" :md="11" :sm="24" :xl="14" :xs="24">
        <div style="color: transparent">占位符</div>
      </el-col>
      <!-- <el-col :lg="14" :md="11" :sm="24" :xl="14" :xs="24">
        <div id="self_defined_element" class="self-defined-classname"></div>
      </el-col> -->

      <el-col :lg="9" :md="12" :sm="24" :xl="9" :xs="24">
        <el-form
          ref="form"
          class="login-form"
          label-position="left"
          :model="form"
          :rules="rules"
        >
          <div
            class="flex-x"
            style="align-items: center; justify-content: center"
          >
            <div
              class="flex-y pos"
              style="justify-content: center; align-items: center; flex: 1"
              v-for="(item, index) of loginArrData"
              :key="index"
              @click="handleIndex(index)"
            >
              <div
                class="btn-title"
                :class="{ 'btn-title-active': currentIndex == index }"
              >
                {{ item }}
              </div>
              <div class="btn-width" v-show="currentIndex == index"></div>
            </div>
          </div>
          <div style="margin-top: 30px" v-show="currentIndex == 0">
            <!-- <div class="title">hello !</div>
            <div class="title-tips">
              {{ translateTitle('欢迎来到') }}{{ title }}！
            </div> -->
            <el-form-item prop="phone" style="margin-top: 40px">
              <el-input
                v-model.trim="form.phone"
                v-focus
                :placeholder="translateTitle('请输入手机号')"
                @input.native="form.phone = checkInputNum($event)"
                tabindex="1"
                type="text"
                maxlength="11"
              >
                <template #prefix>
                  <vab-icon icon="user-line" />
                </template>
              </el-input>
            </el-form-item>
            <!-- 验证码验证逻辑需自行开发，如不需要验证码功能建议注释 -->
            <el-form-item prop="code">
              <el-input
                v-model.trim="form.code"
                @input.native="form.code = checkInputNum($event)"
                :placeholder="translateTitle('验证码') + previewText"
                tabindex="2"
                maxlength="4"
                type="text"
              >
                <template #prefix>
                  <vab-icon icon="barcode-box-line" />
                </template>
              </el-input>
              <img class="code" :src="codeUrl" @click="changeCode" />
            </el-form-item>
            <el-form-item prop="numberCode">
              <el-input
                v-model.trim="form.numberCode"
                :placeholder="translateTitle('请输入验证码')"
                tabindex="3"
                maxlength="6"
                @input.native="form.numberCode = checkInputNum($event)"
                @keyup.enter.native="handleLogin"
              >
                <template #prefix>
                  <vab-icon icon="lock-line" />
                </template>
              </el-input>
              <div class="sendMsg">
                <el-button v-if="!sendMsgDisabled" type="text" @click="count">
                  获取验证码
                </el-button>
                <el-button v-if="sendMsgDisabled" disabled type="text">
                  {{ time + '秒后获取' }}
                </el-button>
              </div>
            </el-form-item>

            <el-button
              class="login-btn"
              :loading="loading"
              type="primary"
              @click="handleLogin"
            >
              {{ translateTitle('登录') }}
            </el-button>
          </div>
          <!-- 钉钉登录 - 暂时隐藏，后续可能恢复 -->
          <!-- <div v-show="currentIndex == 1">
            <div
              class="flex-y pos"
              style="align-items: center; justify-content: center"
            >
              <div
                id="self_defined_element"
                class="self-defined-classname"
              ></div>
              <div style="font-size: 20px">
                打开
                <span style="color: #1890ff">钉钉APP</span>
                - 点击右上角扫一扫
              </div>
            </div>
          </div> -->
          <!-- 飞书登录 -->
          <div v-show="currentIndex == 1">
            <div
              class="flex-y pos"
              style="
                align-items: center;
                justify-content: center;
                margin-top: 40px;
              "
            >
              <div
                id="feishu_qr_container"
                class="self-defined-classname-feishu"
              ></div>
              <div style="font-size: 20px; margin-top: 20px">
                打开
                <span style="color: #1890ff">飞书APP</span>
                - 点击右上角扫一扫
              </div>
            </div>
          </div>
          <div class="mt10 felx-x text-center">
            <el-button type="text" @click="goto(2)">供应商登录</el-button>
          </div>
        </el-form>
      </el-col>
      <el-col :lg="1" :md="1" :sm="24" :xl="1" :xs="24">
        <div style="color: transparent">占位符</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { translateTitle } from '@/utils/i18n'
  import { getCodeImg, sendErpLoginCode } from '@/api/user'
  export default {
    name: 'Login',
    directives: {
      focus: {
        inserted(el) {
          el.querySelector('input').focus()
        },
      },
    },
    beforeRouteLeave(to, from, next) {
      clearInterval(this.timer)
      next()
    },
    data() {
      const validatePhoneNumber = (rule, value, callback) => {
        const regexCN = /^1[3-9]\d{9}$/ // 中国大陆手机号正则
        const regexHK = /^[56789]\d{7}$/ // 香港手机号正则
        const regexTW = /^[9]\d{8}$/ // 台湾手机号正则
        const regexMO = /^6\d{7}$/ // 澳门手机号正则

        if (
          regexCN.test(value) ||
          regexHK.test(value) ||
          regexTW.test(value) ||
          regexMO.test(value)
        ) {
          callback() // 符合条件，通过校验
        } else {
          callback(new Error('请输入有效的中国大陆、香港、澳门或台湾手机号码')) // 不符合条件，不通过校验
        }
      }
      const validateNuberCode = (rule, value, callback) => {
        if ('' === value) {
          callback(new Error(this.translateTitle('手机验证码不能为空')))
        } else {
          if (this.form.numberCode.length != 6) {
            callback(new Error(this.translateTitle('请输入6位数字验证码')))
          }
          if (!this.form.code && String(this.form.code) !== '0') {
            callback(new Error(this.translateTitle('数字验证码不能为空')))
          }
          callback()
        }
      }
      const validateCode = (rule, value, callback) => {
        if ('' === value)
          callback(new Error(this.translateTitle('数字验证码不能为空')))
        else callback()
      }
      return {
        loginArrData: ['验证码登录', /* '钉钉登录', */ '飞书登录'],
        currentIndex: 1,
        sendMsgDisabled: false,
        time: 60,
        form: {
          authUserType: 'ERP',
          code: '',
          numberCode: '',
          phone: '',
          uuid: '',
        },
        rules: {
          phone: [
            {
              required: true,
              trigger: 'blur',
              validator: validatePhoneNumber,
            },
          ],
          numberCode: [
            {
              required: true,
              trigger: 'blur',
              validator: validateNuberCode,
            },
          ],
          code: [
            {
              required: true,
              trigger: 'blur',
              validator: validateCode,
            },
          ],
        },
        loading: false,
        passwordType: 'password',
        redirect: undefined,
        timer: 0,
        codeUrl: 'https://www.oschina.net/action/user/captcha',
        previewText: '',
      }
    },
    computed: {
      ...mapGetters({
        title: 'settings/title',
      }),
    },
    watch: {
      $route: {
        handler(route) {
          this.redirect = (route.query && route.query.redirect) || '/'
        },
        immediate: true,
      },
    },
    created() {
      this.getCode()
      this.checkFeishuCallback()
    },
    mounted() {
      // this.initDingLoginV2() // 暂时隐藏钉钉登录
      this.$nextTick(() => {
        this.initFeishuLogin()
      })
    },
    beforeDestroy() {
      this.destroyFeishuLogin()
    },
    methods: {
      checkFeishuCallback() {
        const urlParams = new URLSearchParams(window.location.search)
        const code = urlParams.get('code')
        const state = urlParams.get('state')
        if (code && state === 'feishu_login') {
          this.loading = true
          this.login({
            authUserType: 'CENTER_FEI_SHU',
            code,
            loginState: 5,
          })
            .then(() => {
              const origin = window.location.origin.replace(/^http:/, 'https:')
              window.location.href = origin + '/'
            })
            .catch(() => {
              this.loading = false
              window.history.replaceState({}, '', window.location.pathname)
            })
        }
      },
      loadFeishuSDK() {
        return new Promise((resolve, reject) => {
          if (window.QRLogin) {
            resolve()
            return
          }
          const script = document.createElement('script')
          script.src =
            'https://lf-package-cn.feishucdn.com/obj/feishu-static/lark/passport/qrcode/LarkSSOSDKWebQRCode-1.0.3.js'
          script.onload = () => {
            if (window.QRLogin) {
              resolve()
            } else {
              reject(new Error('飞书SDK加载成功但QRLogin未暴露'))
            }
          }
          script.onerror = () => reject(new Error('飞书SDK加载失败'))
          document.body.appendChild(script)
        })
      },
      initFeishuLogin() {
        let client_id = 'cli_aabba23438b9dbda'
        let redirect_uri = ''

        if (process.env.NODE_ENV === 'development') {
          redirect_uri = 'https://test.center.girdeargroup.com'
        }
        if (process.env.NODE_ENV === 'test') {
          redirect_uri = 'https://test.center.girdeargroup.com'
        }
        if (process.env.NODE_ENV === 'production') {
          redirect_uri = 'https://center.girdeargroup.com'
          client_id = 'cli_aa9ba6a803785be9'
        }

        const container = document.getElementById('feishu_qr_container')
        if (!container) return
        container.innerHTML = ''

        this.loadFeishuSDK()
          .then(() => {
            const goto = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=${client_id}&redirect_uri=${encodeURIComponent(
              redirect_uri
            )}&response_type=code&state=feishu_login`

            this.QRLoginObj = window.QRLogin({
              id: 'feishu_qr_container',
              goto,
              width: '260',
              height: '260',
              style: 'width:260px;height:260px',
            })

            this._feishuMessageHandler = (event) => {
              if (
                this.QRLoginObj &&
                this.QRLoginObj.matchOrigin(event.origin) &&
                this.QRLoginObj.matchData(event.data)
              ) {
                const loginTmpCode = event.data.tmp_code
                window.location.href = `${goto}&tmp_code=${loginTmpCode}`
              }
            }

            if (typeof window.addEventListener !== 'undefined') {
              window.addEventListener(
                'message',
                this._feishuMessageHandler,
                false
              )
            }
          })
          .catch((err) => {
            console.error('飞书SDK加载失败:', err)
          })
      },
      destroyFeishuLogin() {
        if (this._feishuMessageHandler) {
          window.removeEventListener('message', this._feishuMessageHandler)
          this._feishuMessageHandler = null
        }
        this.QRLoginObj = null
        const container = document.getElementById('feishu_qr_container')
        if (container) {
          container.innerHTML = ''
        }
      },
      handleIndex(index) {
        this.currentIndex = index
        if (index === 1) {
          this.$nextTick(() => {
            this.initFeishuLogin()
          })
        }
      },
      getUrlKeyVal(key) {
        var value = ''
        ///获取当前页面的URL
        var sURL = window.document.URL
        ///URL中是否包含查询字符串
        if (sURL.indexOf('?') > 0) {
          //分解URL,第二的元素为完整的查询字符串
          //即arrayParams[1]的值为【id=1&action=2】
          var arrayParams = sURL.split('?')
          //分解查询字符串
          //arrayURLParams[0]的值为【id=1 】
          //arrayURLParams[2]的值为【action=add】
          var arrayURLParams = arrayParams[1].split('&')
          //遍历分解后的键值对
          for (var i = 0; i < arrayURLParams.length; i++) {
            //分解一个键值对
            var sParam = arrayURLParams[i].split('=')
            if (sParam[0] == key && sParam[1] != '') {
              //找到匹配的的键,且值不为空

              value = sParam[1]

              break
            }
          }
        }
        return value
      },
      //新版方式，可以调起钉钉应用，内嵌
      initDingLoginV2() {
        let redirect_uri = 'http://test.erp.girdeargroup.com'
        let client_id = 'dingolcgzbyss53wzk3e'

        // 测试环境 开发环境 都用这一个
        var currentUrl = window.location.href
        if (process.env.NODE_ENV === 'development') {
          redirect_uri = 'http://dev.center.girdeargroup.com'
          if (currentUrl.includes('https')) {
            redirect_uri = 'https://dev.center.girdeargroup.com'
          }
        }
        if (process.env.NODE_ENV === 'test') {
          redirect_uri = 'http://test.center.girdeargroup.com'
          if (currentUrl.includes('https')) {
            redirect_uri = 'https://test.center.girdeargroup.com'
          }
        }

        if (process.env.NODE_ENV === 'production') {
          redirect_uri = 'http://center.girdeargroup.com'
          if (currentUrl.includes('https')) {
            redirect_uri = 'https://center.girdeargroup.com'
          }
          client_id = 'dinge969fft3kybnklyn'
        }
        window.DTFrameLogin(
          {
            id: 'self_defined_element', // 装钉钉二维码的盒子
            width: 300,
            height: 300,
          },
          {
            redirect_uri: encodeURIComponent(redirect_uri),
            client_id: client_id,
            scope: 'openid',
            response_type: 'code',
            prompt: 'consent',
            state: 'dddd',
          },
          (loginResult) => {
            const { redirectUrl } = loginResult
            const url = new URL(redirectUrl)
            const params = new URLSearchParams(url.search)
            let authCode = params.get('authCode')
            this.login({
              authUserType: 'CENTER_DING_TALK',
              code: authCode,
              loginState: 2,
            })
              .then(() => {
                authCode = ''
                window.open(`${url.origin}`, '_self')
              })
              .catch((err) => {
                if (err.code == 20211) {
                  authCode = ''
                  // 这里必须要执行刷新页面 不然继续扫码会调用多次login
                  setTimeout(() => {
                    window.open(`${url.origin}`, '_self')
                  }, 2000)
                }
              })
          },
          (errorMsg) => {
            // 这里一般需要展示登录失败的具体原因
            console.log(`Login Error: ${errorMsg}`)
          }
        )
      },
      _getRandomString(len) {
        len = len || 10
        let $chars = 'ABCDEFGHIJKMNOPQRSTUVWXYZ' // 默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
        let maxPos = $chars.length
        let pwd = ''
        for (var i = 0; i < len; i++) {
          pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
        }
        return pwd
      },
      getCode() {
        getCodeImg().then((res) => {
          console.log('🚀 ~ getCodeImg ~ res:', res)
          this.codeUrl = 'data:image/gif;base64,' + res.data.img
          this.form.uuid = res.data.uuid
        })
      },
      ...mapActions({
        login: 'user/login',
      }),
      translateTitle,
      count() {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        if (this.form.phone && reg.test(this.form.phone)) {
          this.sendMsgDisabled = true
          sendErpLoginCode({
            phone: this.form.phone,
            uuid: this.form.uuid,
            code: this.form.code,
            authUserType: 'CENTER',
          })
            .then(() => {
              this.interval = window.setInterval(() => {
                if (this.time-- <= 0) {
                  this.time = 60
                  this.sendMsgDisabled = false
                  window.clearInterval(this.interval)
                }
              }, 1000)
            })
            .catch(() => {
              this.sendMsgDisabled = false
              this.getCode()
            })
        } else {
          this.translateTitle('请输入正确手机号')
        }
      },
      handleRoute() {
        return this.redirect === '/404' || this.redirect === '/403'
          ? '/'
          : this.redirect
      },
      handleLogin() {
        this.$refs.form.validate(async (valid) => {
          if (valid)
            try {
              this.loading = true
              await this.login({
                validateCode: this.form.numberCode,
                phone: this.form.phone,
                authUserType: 'CENTER',
                code: this.form.code,
                uuid: this.form.uuid,
                loginState: 1,
              }).catch(() => {
                this.getCode()
              })
              await this.$router.push('/')
            } finally {
              this.loading = false
            }
        })
      },
      goto(type) {
        if (type == 1) {
          process.env.NODE_ENV === 'test'
            ? window.open('http://test.erp.girdeargroup.com/areaLeader/#/login')
            : window.open('http://erp.girdeargroup.com/areaLeader/#/login')
        } else {
          process.env.NODE_ENV === 'test'
            ? window.open('http://test.erp.girdeargroup.com/supplier/#/login')
            : window.open(
                'http://erp.girdeargroup.com/supplier/index.html#/login'
              )
        }
      },
      changeCode() {
        this.getCode()
      },
    },
  }
</script>

<style>
  /* STEP2：指定这个包裹容器元素的CSS样式，尤其注意宽高的设置 */
  .self-defined-classname {
    width: 300px;
    height: 300px;
  }
  .self-defined-classname-feishu {
    height: 260px;
    width: 260px;
  }
</style>
<style lang="scss" scoped>
  .login-container {
    height: 100vh;
    background: url('~@/assets/login_images/background.jpg') center center fixed
      no-repeat;
    background-size: cover;
  }

  .login-form {
    position: relative;
    max-width: 100%;
    padding: 4.5vh;
    margin: calc((100vh - 475px) / 2) 5vw 5vw;
    overflow: hidden;
    background: #fff;
    box-shadow: 0px 0px 10px 1px rgba(213, 226, 252, 0.1);
    border-radius: 25px 25px 25px 25px;
    .title {
      font-size: 54px;
      font-weight: 500;
      color: #454545;
    }

    .title-tips {
      margin-top: 29px;
      font-size: 26px;
      font-weight: 400;
      color: #454545;
    }

    .login-btn {
      display: inherit;
      width: 100%;
      height: 50px;
      margin-top: 5px;
      border: 0;
      background-color: #1890ff;
      &:hover {
        opacity: 0.9;
      }

      .forget-passwordword {
        width: 100%;
        margin-top: 40px;
        text-align: left;

        .forget-password {
          width: 129px;
          height: 19px;
          font-size: 20px;
          font-weight: 400;
          color: rgba(92, 102, 240, 1);
        }
      }
    }

    .tips {
      margin-bottom: 10px;
      font-size: $base-font-size-default;
      color: $base-color-white;

      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }

    .title-container {
      position: relative;

      .title {
        margin: 0 auto 40px auto;
        font-size: 34px;
        font-weight: bold;
        color: $base-color-blue;
        text-align: center;
      }
    }

    i {
      position: absolute;
      top: 8px;
      left: 5px;
      z-index: $base-z-index;
      font-size: 16px;
      color: #d7dee3;
      cursor: pointer;
      user-select: none;
    }

    .show-password {
      position: absolute;
      right: 25px;
      left: -35px;
      font-size: 16px;
      color: #d7dee3;
      cursor: pointer;
      user-select: none;
    }

    :deep() {
      .el-form-item {
        padding-right: 0;
        margin: 20px 0;
        color: #454545;
        background: transparent;
        border: 1px solid transparent;
        border-radius: 2px;

        &__content {
          min-height: $base-input-height;
          line-height: $base-input-height;
        }

        &__error {
          position: absolute;
          top: 100%;
          left: 18px;
          font-size: $base-font-size-small;
          line-height: 18px;
          color: $base-color-red;
        }
      }

      .el-input {
        box-sizing: border-box;

        input {
          height: 48px;
          padding-left: 35px;
          font-size: $base-font-size-default;
          line-height: 58px;
          background: #f6f4fc;
          border: 0;
        }
      }

      .code {
        height: 40px;
        position: absolute;
        top: 4px;
        right: 4px;
        cursor: pointer;
        border-radius: $base-border-radius;
      }
    }
  }
  .sendMsg {
    position: absolute;
    right: 22px;
    top: 8px;
  }
  .btn-title {
    font-size: 24px;
    cursor: pointer;
    color: #cccccc;
    white-space: nowrap;
  }
  .btn-title-active {
    color: #222222;
  }
  .pos {
    position: relative;
  }
  .btn-width {
    width: 60px;
    height: 3px;
    background-color: #1890ff;
    position: absolute;
    bottom: -10px;
    z-index: 999;
  }
</style>
